import React from 'react'
import styled from '@emotion/styled'
import {Color} from '../../../Styles'

const DEFAULT_COLOR = Color.Grey800

export type PIMBaseLabelProps = {
  children: React.ReactNode
  fontRemSize: number
  bold?: boolean
  color?: string
  lineHeight?: number
}

const StyledDiv = styled.div`
  font-size: ${({fontRemSize}: PIMBaseLabelProps): number => fontRemSize}rem;
  font-weight: ${({bold}: PIMBaseLabelProps): string => bold ? 'bold' : 'normal'};
  color: ${({color}: PIMBaseLabelProps): string => color ?? DEFAULT_COLOR};
  line-height: ${({lineHeight}: PIMBaseLabelProps): number => lineHeight ?? 1};
`

export const PIMBaseLabel: React.VFC<PIMBaseLabelProps> = (props) => {
  const {children, ...rest} = props

  return (
    <StyledDiv {...rest}>{children}</StyledDiv>
  )
}
